type TMessageType = {
    message: string;
    closeClickHandler?: () => void;
};

export const ErrorMessageSticky = ({ message, closeClickHandler }: TMessageType) => {
    return (
        <div className="alert alert-danger bg-danger text-white p-3 px-md-4 mt-2 mx-auto shadow-lg error-message-alert" role="alert" aria-live="assertive">
            <div className="row gx-4 align-items-start">
                <div className="col-auto align-self-center">
                    <div className="rounded-circle bg-white bg-opacity-10 text-center error-message-alert-icon">
                        <i className="fa-solid fa-triangle-exclamation fs-5" aria-hidden="true"></i>
                    </div>
                </div>
                <div className="col align-self-center text-start pe-2">
                    <div className="small lh-base">{message}</div>
                </div>
                <div className="col-auto">
                    <button type="button" className="btn-close btn-close-white mt-0" aria-label="Close alert" onClick={closeClickHandler}></button>
                </div>
            </div>
        </div>
    );
};

export const ErrorMessageFraud = ({ closeClickHandler }: { closeClickHandler?: () => void }) => {
    return (
        <ErrorMessageSticky
            closeClickHandler={closeClickHandler}
            message="We detected your content may be considered as Advertising, Scam or Fraud, please review it and try again."
        />
    );
};
